import gql from "graphql-tag";

export const surveyQuery = gql`
  query survey($surveyId: ID!) {
    survey(id: $surveyId) {
      id
      title
      text
      buttonText
      url
      startsAt
      endsAt
      maxShows
    }
  }
`;
